import React from 'react';
import PropTypes from 'prop-types';
import AntdPopover from 'antd/lib/popover';
import Icon from 'components/Icon';

/**
 * 字体图标，兼容antd的图标
 */
class Popover extends React.Component {
  static propTypes = {
    // content: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    title: window.language['common.tip'],
    className: 'custom-popover',
  };

  render() {
    let {
      content,
      children,
      className,
      antd,
      ...props
    } = this.props;
    content = (<React.Fragment>
      <Icon className="client-exception" />
      <div>
        {content}
      </div>
    </React.Fragment>);
    return antd ? null : (
      <AntdPopover content={content} overlayClassName={className} {...props}>
        {children}
      </AntdPopover>
    );
  }
}

export default Popover;



// WEBPACK FOOTER //
// ./src/components/Popover/Popover.js